<h1 mat-dialog-title class="p-2 text-center"> Option pour la génération de la synthèse chantier</h1>
<div class="row g-0">
    <div class="row my-3">
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.IncludeProcess">
            Avec Processus
        </mat-slide-toggle>

        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.IncludeMC">
            Avec Mesures complémentaires
        </mat-slide-toggle>

        <!-- <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.IncludeMEST">
            Avec MEST
        </mat-slide-toggle>

        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.IncludeMateriaux">
            Avec Matériaux
        </mat-slide-toggle> -->

    </div>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
        Non
    </button>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()">
        Oui
    </button>
</div>